import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const BookingRequest = (props: TSvgAssetProps) => (
  <SvgAsset width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" fill="none" />
    <path d="M8 11h8" fill="none" />
    <path d="M8 7h6" fill="none" />
  </SvgAsset>
);

export default BookingRequest;
